import StandardLayout from '@/common/layouts/StandardLayout';
import useLeaderboard from '@/hooks/useLeaderboard';
import Flatpickr from 'react-flatpickr';
import DataTable from '@/common/tableData/DataTable';
import LeaderboardPayoutActions from './components/LeaderboardPayoutActions';
import styles from './leaderboards.module.css';
import classNames from 'classnames';
import { previousMonday } from 'date-fns';
import { IoMdRefresh } from 'react-icons/io';
import { Button } from 'reactstrap';
import { LeaderboardPayout } from '@repo/common-types';
import { Row } from '@tanstack/react-table';

const LeaderboardPayoutsPage = () => {
  const { payouts, searchDate, setSearchDate, retryFailedPayout, isRetryFailedPayoutLoading, refetchPayouts } =
    useLeaderboard();

  const handleDateChange = (dates: Date[]) => {
    setSearchDate(dates[0]);
  };

  return (
    <StandardLayout
      pageTitle="Leaderboard Payouts"
      headerButton={
        <div className="d-flex align-items-center gap-2">
          <Button variant="primary" color="dark" onClick={() => refetchPayouts()}>
            <IoMdRefresh size={20} />
          </Button>
          <div className={classNames('input-group', styles.dateSelectContainer)}>
            <Flatpickr
              className="form-control mw-100 border-0 shadow"
              options={{
                mode: 'single',
                dateFormat: 'Y-m-d',
                defaultDate: searchDate ? searchDate : previousMonday(new Date()),
                enable: [
                  (date) => {
                    if (date.getDay() === 1) {
                      return true;
                    }
                    return false;
                  },
                ],
              }}
              onChange={handleDateChange}
            />
            <div className="input-group-text bg-primary border-primary text-white">
              <i className="ri-calendar-2-line"></i>
            </div>
          </div>
        </div>
      }
    >
      {payouts && payouts.length > 0 ? (
        <DataTable
          columns={[
            {
              id: 'rank',
              header: 'Rank',
              accessorKey: 'rank',
            },
            {
              id: 'alias',
              header: 'Alias',
              accessorKey: 'user.alias',
            },
            {
              id: 'reward',
              header: 'Reward',
              accessorKey: 'reward',
              cell: ({ row }: { row: Row<LeaderboardPayout> }) => (
                <span className="d-flex align-items-center gap-2">${row.original.reward?.toFixed(2) ?? '0.00'}</span>
              ),
            },
            {
              id: 'transactionStatus',
              header: 'Transaction Status',
              accessorKey: 'transaction.status',
            },
            {
              id: 'actions',
              cell: ({ row }: { row: Row<LeaderboardPayout> }) => (
                <LeaderboardPayoutActions
                  payout={row.original}
                  retryFailedPayout={retryFailedPayout}
                  isRetryFailedPayoutLoading={isRetryFailedPayoutLoading}
                />
              ),
            },
          ]}
          enableSorting={false}
          data={payouts}
        />
      ) : (
        <p>No payouts found</p>
      )}
    </StandardLayout>
  );
};

export default LeaderboardPayoutsPage;
